import { useWindowSize } from '@vueuse/core';
import { computed } from 'vue';

/**
 * @param mobileBreakpoint - Viewport width (px) below which `isMobile` is true. Default 768.
 * @returns isMobile - True when viewport width ≤ breakpoint (resize/narrow window = mobile layout).
 * @returns isTouchDevice - True when the device appears touch-capable (maxTouchPoints > 0, or UA suggests iOS/Android as fallback).
 *   Use `isMobile && isTouchDevice` when you need "mobile phone" logic.
 */
export function useMobile(mobileBreakpoint: number = 768) {
  const { width: windowWidth } = useWindowSize();

  const isMobile = computed(() => windowWidth.value <= mobileBreakpoint);
  const isTouchDevice = computed(() => {
    if (typeof navigator === 'undefined') return false;
    if (navigator.maxTouchPoints > 0) return true;
    const ua = navigator.userAgent;
    return /iPhone|iPod|Android/i.test(ua);
  });

  return {
    isMobile,
    isTouchDevice,
  };
}
